import React from 'react';
import accountManagement from '../../../../../apis/accountManagement';
import KelasSearch from '../../../../../entity/KelasSearch';
import { CONFIG } from '../../../../../config';
import KelasDropdown from './KelasDropdown';
import cbtManagement from '../../../../../apis/cbtManagement';
import ProfilSearch from '../../../../../entity/ProfilCbtSearch';
import {connect} from 'react-redux';
import __ from 'lodash';
import ProfilCbtList from './ProfilCbtList';
import ProfilCbtSearch from '../../../../../entity/ProfilCbtSearch';
import Loader from '../../../../Loader';

class CbtPsep extends React.Component{
    state = {
        kelas:[], 
        sekolah:{}, 
        selectedKelas: null, 
        profilCbt: [], 
        loadCbt: false, 
        namaProfilFilter: null, 
        page: 0, 
        size: 5,
        endPage: false,
        totalData: 0,
        loadButton: false
    }
    componentDidMount(){
        console.log("PROPS CBT PSEP :::: ");
        console.log(this.props);
        if(!__.isEmpty(this.props.account)){
            this.fetchKelas();
        }
    }

    fetchKelas = async () =>{
        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){

        })
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {...KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah}).catch(function(error){

        });
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }

        this.fetchProfil();
    }

    fetchProfil = async (currentProfilCbt) => {
        if(currentProfilCbt == null){
            this.setState({loadCbt: true});
        }
        this.setState({
            loadButton: true
        })
        const response = await cbtManagement.post(CONFIG.CBT_MANAGEMENT_PROFIL_CBT_SEARCH + "?page="+ this.state.page +"&size=" + this.state.size, 
            {...ProfilCbtSearch, 
                ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah, 
                ["idKelas"]: this.state.selectedKelas,
                ["idSekolah"]: this.state.sekolah.idSekolah,
                ["kodeTipeCbt"]: "TOO",
                ["namaProfil"]: this.state.namaProfilFilter
            }).catch(function(error){

        })
        if(response){
            if(response.data !== null){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    console.log("PROFIL CBT LENGTH ::: " + this.state.profilCbt.length)
                    if(currentProfilCbt != null){
                        this.setState({
                            profilCbt: [...currentProfilCbt, ...response.data.data.data]
                        })
                    }else{
                        this.setState({
                            profilCbt: response.data.data.data
                        })
                    }
                    this.setState({
                        page: response.data.data.page,
                        totalData: response.data.data.total
                    })
                }
            }
        }
        if(currentProfilCbt == null){
            this.setState({loadCbt: false});
        }
        this.setState({
            loadButton: false
        })
    }

    componentDidUpdate(prevProps, prevStates){
        if(__.isEmpty(prevProps.account) && !__.isEmpty(this.props.account)){
            console.log(this.props.account);
            this.fetchKelas();
        }

        //query profil berdasarkan kelas
        if(prevStates.selectedKelas !== this.state.selectedKelas){
            this.fetchProfil(null);
        }

        if(prevStates.namaProfilFilter !== this.state.namaProfilFilter){
            this.fetchProfil(null);
        }
        console.log("previous page ::: " + prevStates.page);
        console.log("current page ::: " + this.state.page);
        if(parseInt(prevStates.page) != parseInt(this.state.page)){
            
            this.fetchProfil(this.state.profilCbt);
        }
    }

    kelasOnChange = (idKelas) => {
        console.log("kelas terpilih");
        console.log(idKelas);
        this.setState({
            selectedKelas: idKelas,
            page: 0
        })
    }

    namaProfilOnChange = (event) => {
        this.setState({
            page: 0
        })
        console.log(event);
        this.setState({
            namaProfilFilter: event.target.value
        })
    }

    pageNav = (nav) => {
        if(this.state.totalData > 0){
            if(this.state.page === 0 && nav === "right"){
                console.log("arrow 1");
                return (
                    <button className="btn btn-primary" onClick={this.onClickNextPage}>&rsaquo;</button>
                )
            }
            const isEnd = (this.state.page + 1) * this.state.size  >= (this.state.totalData - this.state.size);

            if(isEnd && nav === "left"){
                console.log("arrow 2");
                return (
                    <button className="btn btn-primary" onClick={this.onClickPrevPage}>&lsaquo;</button>
                )
            }
    
            if(nav === "left" && this.state.page > 0 && !isEnd){
                console.log("arrow 3");
                return (
                    <button className="btn btn-primary" onClick={this.onClickPrevPage}>&lsaquo;</button>
                )
            }
    
            if(nav === "right" && this.state.page > 0 && !isEnd){
                console.log("arrow 4");
                return (
                    <button className="btn btn-primary" onClick={this.onClickNextPage}>&rsaquo;</button>
                )
            }
        }
    }

    onClickNextPage = () => {
        this.setState({
            page: this.state.page + 1
        })
    }
    onClickPrevPage = () => {
        this.setState({
            page: this.state.page - 1
        })
    }

    onLoadMore = () => {
        this.setState({
            page: this.state.page + 1
        })
    }

    loadMoreButton = () => {
        if(this.state.loadButton){
            return(
                <Loader />
            )
        }else{
            if(!((this.state.page + 1) * this.state.size >= this.state.totalData)){
                return(
                    <div className="col-12 text-center">
                        <button onClick={this.onLoadMore} className="btn btn-primary">Load more <i class="material-icons" style={{fontSize: '12px'}}>autorenew</i></button>
                    </div>
                )
            }
        }
    }

    render(){
        return(
            <div>
                <div className="row">
                    <div className="col-md-6 col-lg-6">
                        <KelasDropdown kelas={this.state.kelas} onChange={this.kelasOnChange}/>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <input className="form-control" placeholder="Nama profil" value={this.state.namaProfilFilter} onChange={this.namaProfilOnChange}></input>
                    </div>
                    <div className="col-12 col-md-8 col-lg-8">
                        <br></br>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4">
                        <br></br>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" style={{width: "100%"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">Rata-rata nilai</div>
                        </div>
                        <div className="progress">
                            <div className="progress-bar bg-success" role="progressbar" style={{width: "100%"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">Siswa selesai</div>
                        </div>
                        <br></br>
                    </div>
                    <div className="col-md-12 col-lg-12">
                        <ProfilCbtList profilCbt={this.state.profilCbt} isLoading={this.state.loadCbt} kelas={this.state.kelas} sekolah={this.state.sekolah}/>
                    </div>
                    <div className="col-lg-12">
                        <br></br>
                        {this.loadMoreButton()}
                    </div>
                    {/* <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                        {this.pageNav('left')}
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        {this.pageNav('right')}
                    </div> */}
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return{
        account: state.account
    };
}
export default connect(mapStateToProps)(CbtPsep);